import React, { useEffect, useState } from 'react';
import HeroScreen from '../../../Views/HeroScreen';
import AnimeCard from './AnimeCard';
import SEOHead from '../../SEO/SEOHead';
import './AnimeStyle.css';

const TopUpcoming = () => {
    const [animeList, setAnimeList] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchTopUpcoming = async () => {
            try {
                const res1 = await fetch('https://api.jikan.moe/v4/top/anime?filter=upcoming&page=1&limit=25');
                const data1 = await res1.json();
                const page1 = data1.data || [];
                setAnimeList(page1);
                setLoading(false);

                await new Promise(r => setTimeout(r, 400));
                const res2 = await fetch('https://api.jikan.moe/v4/top/anime?filter=upcoming&page=2&limit=25');
                const data2 = await res2.json();
                setAnimeList([...page1, ...(data2.data || [])]);

                await new Promise(r => setTimeout(r, 400));
                const res3 = await fetch('https://api.jikan.moe/v4/top/anime?filter=upcoming&page=3&limit=25');
                const data3 = await res3.json();
                setAnimeList(prev => [...prev, ...(data3.data || [])]);
            } catch (error) {
                console.error('Error fetching upcoming anime:', error.message);
            } finally {
                setLoading(false);
            }
        };
        fetchTopUpcoming();
    }, []);

    return (
        <div className="anime-page-top-upcoming">
            <SEOHead title="ChibiDash | Top Upcoming Anime" description="See the most anticipated upcoming anime. Stay ahead with ChibiDash's upcoming anime list." path="/animehub/top-upcoming" />
            <HeroScreen apiUrl="https://api.jikan.moe/v4/top/anime?filter=upcoming" />
            <h2 className="small-cards-title">Upcoming Anime</h2>
            <p className="results-count">{animeList.length} anime found</p>
            {loading ? (
                <div className="loading-spinner-container">
                    <div className="loading-spinner"></div>
                    <p className="loading-text">Loading Upcoming Anime...</p>
                </div>
            ) : animeList.length > 0 ? (
                <div className="small-anime-grid">
                    {animeList.map((anime) => (
                        <AnimeCard key={anime.mal_id} anime={anime} />
                    ))}
                </div>
            ) : (
                <p className="empty-text">No upcoming anime found.</p>
            )}
        </div>
    );
};

export default TopUpcoming;
